export enum SpecialSymbolsEnum {
	EN_Dash = '–',
	STAR = '✱',
}
